module.exports = __webpack_public_path__ + "static/media/440461219_1866594820510506_3073172461423709613_n.da799b7a.jpg";